//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, {IHttpService} from 'angular';

const SHOWROOM_STATS_PATH = '/showroom/stats';

export default class ShowroomMetricsApiService {
  constructor(
        private $http: IHttpService,
        private promiseService,
        private RestBaseUrl,
    ) {}

  public getMetadataAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/metadata`,
            { params },
        ));
  }

  public getSummaryStatsAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/summary`,
            { params },
        ));
  }

  public getGraphStatsAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/graph`,
            { params },
        ));
  }

  public getPostStatsAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/posts`,
            { params },
        ));
  }

  public getItemStatsAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/items`,
            { params },
        ));
  }

  public getProductStatsAsync(params): Promise<any> {
    return this.promiseService.processHttpResponse(this.$http.get(
            `${this.RestBaseUrl}${SHOWROOM_STATS_PATH}/products`,
            { params },
        ));
  }
}

angular.module('curalate').service('ShowroomMetricsApiService', [
  '$http',
  'PromiseService',
  'RestBaseUrl',
  ShowroomMetricsApiService,
]);
